export default __webpack_public_path__ + "static/media/featured-punchbowl.e73fd7b2.webp";